import type { StateCreator } from "zustand";

/**
 * Interface representing a collection of video answers.
 * Keys are answer IDs (strings) and values are the corresponding answer values (strings).
 */
interface VideoAnswers {
  [answerId: string]: string;
}

export interface VideoAnswersSliceState {
  videoAnswers: VideoAnswers;
}

interface VideoAnswersSliceActions {
  setVideoAnswer: (answerId: string, value: string) => void;
  getVideoAnswer: (answerId: string) => string;
  resetVideoAnswers: () => void;
}

export type VideoAnswersSlice = VideoAnswersSliceState & VideoAnswersSliceActions;

export const createVideoAnswersSlice: StateCreator<
  VideoAnswersSlice,
  [["zustand/devtools", never]],
  [],
  VideoAnswersSlice
> = (set, get) => ({
  videoAnswers: {},
  setVideoAnswer: (answerId: string, value: string) =>
    set((state) => ({
      videoAnswers: {
        ...state.videoAnswers,
        [answerId]: value,
      },
    })),
  getVideoAnswer: (answerId: string) => {
    const state = get();
    return state.videoAnswers[answerId] || "";
  },
  resetVideoAnswers: () =>
    set(() => ({
      videoAnswers: {},
    })),
});
